import React from 'react'
import "./OurFeature.css";
import feature1 from "../images/png/image 64.png"
import feature2 from "../images/png/image 64 (1).png"
import feature3 from "../images/png/image 64 (2).png"
import feature4 from "../images/png/image 64 (3).png"




const OurFeature=()=>{
  return (
    <div>
        <div className='Ourtrust'>
            <div className='featured'>
                <h1>Our Featured Services</h1>
                <p>Discover the range of services provided by Fliqaindia</p>  
            </div>
            <div className='featureCard'>
                <div>
                  <h1>{'<'}</h1>
                </div>
                <div className='Fcard'>
                    <div className='Fimg'>
                        <img src={feature1} alt="err"/>
                    </div>
                    <div className='FWeding'>
                        <h2>Pre Wedding Photoshoot</h2>
                        <hr/>
                        <h3>Starting at 25,000 (One Day)</h3>
                        <button type="submit">Know more</button>
                        
                    </div>
                    
                </div>
                <div className='Fcard'>
                    <div className='Fimg'>
                        <img src={feature2} alt="err"/>
                    </div>
                    <div className='FWeding'>
                        <h2>Pre Wedding Photoshoot</h2>
                        <hr/>
                        <h3>Starting at 65,000 (Two days)</h3>
                        <button type="submit">Know more</button>
                        
                    </div>
                    
                </div>
                <div className='Fcard'>
                    <div className='Fimg'>
                        <img src={feature3} alt="err"/>
                    </div>
                    <div className='FWeding'>
                        <h2>Portfolio Shoot</h2>
                        <hr/>
                        <h3>Starting at 25,000 (Standard at6-8 hours)</h3>
                        <button type="submit">Know more</button>
                        
                    </div>
                    
                </div>
                <div className='Fcard'>
                    <div className='Fimg'>
                        <img src={feature4} alt="err"/>
                    </div>
                    <div className='FWeding'>
                        <h2>Birthday Baby Folio</h2>
                        <hr/>
                        <h3>Starting at 15,000 (One Day)</h3>
                        <button type="submit">Know more</button>
                        
                    </div>
                    
                </div>
                <div>
                  <h1>{'>'}</h1>
                </div>
                
            </div>
            
        </div>

    </div>
  )
}
export {OurFeature}
